export default __webpack_public_path__ + "static/media/quantity_add_over.41fa8e4c.svg";